import request from '../request'
import { UseQueryResult, useQuery } from 'react-query'
import { Pagination } from '../../lib/types/Pagination'
import { useBuildQueryParams } from '../../lib/hooks/useBuildQueryParams'

type ResultType = {
  id: number
  dealership: string
  client_id: number
  demand_local_net: number
  gross_revenue: number
  campaigns: number
  campaign_types: string
  impressions: number
  clicks: number
  views: number
}

export const useGetAgencyProfileDealerships = ({
  pageIndex,
  pageSize,
  filters,
}: {
  pageIndex: number
  pageSize: number
  filters: Record<string, unknown>
}): UseQueryResult<{ data: ResultType[]; pagination: Pagination }, Error> => {
  const queryParams = useBuildQueryParams(filters)
  return useQuery<{ data: ResultType[]; pagination: Pagination }, Error>(
    ['agencies', 'profile', 'dealerships', { pageSize, pageIndex, queryParams }],
    ({ signal }) =>
      request({
        url: `/agencies/${queryParams?.agency_id}/profile/dealerships`,
        method: 'GET',
        params: { pageIndex, pageSize, ...queryParams },
        signal,
      }),
    {
      enabled: !!queryParams.agency_id,
    },
  )
}
